import { imageUrlsFor } from "../helper/UrlResolver";
import { SongUb } from "../gql/graphql";

export function buildUrlListForAllPagesOfAllSongs(
  songs: readonly SongUb[],
): Set<string> {
  return new Set(songs.flatMap((s) => imageUrlsFor(s)));
}
